import axios from "src/configs/axios";

const operations = {
  removeFromCart: async (product) => {
    const reqBody = {
      code: product.code,
      wage: product.wage,
      old_toman_price: product.old_toman_price,
      toman_price: product.toman_price,
      delivery_price: product.delivery_price,
      tax: product.tax,
      total_price: product.total_price,
    };

    const { data } = await axios.post("/cart/delete", { ...reqBody });

    return data;
  },

  createCartProduct: async (product) => {
    const { price, deliveryType } = product;

    const reqBody = {
      code: product.code,
      title: product.title,
      image: product.images[0].large,
      saving_percent: price.saving_percent,
      wage: price.wage,
      old_toman_price: price.old_toman_price,
      toman_price: price.toman_price,
      delivery_price: price.delivery_price,
      tax: price.tax,
      user_delivery_type: deliveryType || 0,
      total_price: price.total_price,
      old_dirham_price: price.old_dirham_price,
      dirham_price: price.dirham_price,
      dirham_to_toman_price: price.dirham_to_toman_price,
      description: product.description || null,
      product_description: product.product_description || null,
      product_id: product.product_id || null,
    };

    const { data } = await axios.post("/cart/add", { ...reqBody });

    return data;
  },
  addToCart: async (product) => {
    const reqBody = {
      code: product.code,
      wage: product.wage,
      old_toman_price: product.old_toman_price,
      toman_price: product.toman_price,
      delivery_price: product.delivery_price,
      tax: product.tax,
      total_price: product.total_price,
    };

    const { data } = await axios.post("/cart/increase", { ...reqBody });

    return data;
  },

  fetchCart: async () => {
    const { data } = await axios.get("/cart/cart", {});

    return data;
  },

  addPartnerShip: async (code) => {
    const { data } = await axios.post("/orders/add-partnership", { code });

    return data;
  },
};

export default operations;
